import { createApp } from 'vue'
import App from './App.vue'
import installElementPlus from './plugins/element'
import router from './router'
import '@/assets/reset.css'
import ElementPlus from 'element-plus';
import Vue3Marquee from 'vue3-marquee'
import './assets/iconfont/iconfont.css'
import { getValue } from './utils/auth'

let isInitialNavigation = true

router.beforeEach((to, from, next) => {
  if (isInitialNavigation) {
    isInitialNavigation = false
    if (to.name === 'login' || to.name === 'login-mobile') {
      next({ name: 'index', replace: true })
      return
    }
  }

  document.title = 'Southern Atlantic Service - ' + (to.meta.title || 'Default Title')
  if (to.path == '/menus') {
    const role = getValue('maintain-role')
    const token = getValue('maintain-token')
    
    if (!token) {
      next({ name: 'login' })
    } else if (role == 'admin') {
      next('/adminmenus') // 管理员跳后台
    } else if (role == 'dispatcher') {
      next('/dispatchmenus') // 调度员跳调度台
    } else {
      next()
    }
    return
  }
  next()
})

const app = createApp(App).use(router)
installElementPlus(app)
app.use(router).use(ElementPlus).use(Vue3Marquee)
app.mount('#app');